import { Icon } from '@chakra-ui/react';
import { KText } from '../../text';

export const KTagWithIcon = ({
  value = '',
  isTable = false,
  icon,
  iconProps,
  ...props
}: any) => {
  return (
    <KText
      textAlign="start"
      border="1px solid"
      borderColor="transparent"
      bgColor="secondary-50"
      borderRadius="xs"
      p="0.125em 0.5em"
      fontWeight={550}
      _groupHover={
        isTable ? { bg: 'base-white', borderColor: 'border-color' } : {}
      }
      display="flex"
      alignItems="center"
      gap="6px"
      {...props}
    >
      <Icon
        as={icon}
        width="16px"
        height="16px"
        color="secondary-700"
        {...iconProps}
      />
      {value}
    </KText>
  );
};
